// Usage:
//   <button data-controller="navigate-back" data-action="click->navigate-back#back">Back</button>

import { Controller } from "stimulus"

export default class extends Controller {
  back() {
    history.back()
  }
}
